import React from 'react';
import { Network, Sparkles, PhoneForwarded } from 'lucide-react';
import Reveal from '../saas/Reveal';

const ICONS = [Sparkles, Network, PhoneForwarded];

/** ارزش‌ proposition — ردیف‌های پهن با آیکن شاخص (بدون لیست نقطه‌ای) */
export function SmallBusinessPillars({ items }) {
  return (
    <div className="flex flex-col gap-3 sm:gap-4">
      {items.map((text, i) => {
        const Icon = ICONS[i] || Sparkles;
        return (
          <Reveal
            key={i}
            delayMs={i * 75}
            className="group relative overflow-hidden rounded-[1.25rem] border border-hairline/35 bg-gradient-to-l from-card-surface to-sky-wash/[0.35] p-5 shadow-saas transition duration-300 ease-out hover:border-signal/22 hover:shadow-saas-md sm:p-6 md:flex md:items-center md:gap-6"
          >
            <div className="mb-4 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-cta-gradient/12 text-signal shadow-inner ring-1 ring-signal/10 transition duration-300 group-hover:scale-[1.05] md:mb-0 md:h-16 md:w-16">
              <Icon className="h-7 w-7 stroke-[1.85] md:h-8 md:w-8" strokeLinecap="round" strokeLinejoin="round" aria-hidden />
            </div>
            <p className="min-w-0 flex-1 text-[0.9375rem] font-medium leading-[1.75] text-ink-graphite sm:text-base sm:leading-[1.7]">
              {text}
            </p>
            <div
              className="pointer-events-none absolute inset-y-0 start-0 w-[3px] rounded-e-full bg-gradient-to-b from-signal via-signal/80 to-signal/40 opacity-90 transition-opacity group-hover:opacity-100"
              aria-hidden
            />
          </Reveal>
        );
      })}
    </div>
  );
}
